import { canvasToPdfPoints } from "../../../../utils/coordinateUtils";

export const handleMouseUp = (
  currentProcessingFile,
  setCurrentProcessingFile,
  resizing,
  setResizing,
  setCurrCursor,
  moving,
  setMoving,
  isDrawing,
  rect,
  setIsDrawing,
  setRect,
  fixedInputs,
  isSelecting,
  setIsSelecting,
  setSelectionRect,
  setFreeSelectStartPoint,
) => {
  if (resizing && setResizing) {
    setResizing(false);
    setCurrCursor("default");
  } else if (moving) {
    setMoving(false);
    setCurrCursor("default");
    // Clear any lingering drawing/selection states when finishing a move
    setIsDrawing(false);
    setIsSelecting(false);
    setSelectionRect(null);
  } else if (isDrawing) {
    let MIN_WIDTH = 20;
    let MIN_HEIGHT = 10;

    const currentDocument =
      currentProcessingFile?.document?.tempFields?.currentDocument || {};
    const pdfRect = canvasToPdfPoints(
      rect.x * (currentDocument.scaleFactor || 1),
      rect.y * (currentDocument.scaleFactor || 1),
      rect.width * (currentDocument.scaleFactor || 1),
      rect.height * (currentDocument.scaleFactor || 1),
      currentDocument.viewport || currentDocument.scaleFactor || 1,
      72,
      currentDocument.actualHeight || 792,
      currentDocument.pageXMin || 0,
      currentDocument.pageYMin || 0,
    );
    let fieldHeight = pdfRect.height;
    let fieldWidth = pdfRect.width;
    let fieldX = pdfRect.x;
    let fieldY = pdfRect.y;

    // ✅ Define minimum dimensions
    if (
      currentProcessingFile?.document?.tempFields?.formFieldTools.checkbox
        .active ||
      currentProcessingFile?.document?.tempFields?.formFieldTools.radio.active
    ) {
      if (fieldWidth < 10) {
        fieldWidth = 10;
      }
      const maxSize = Math.max(fieldWidth, fieldHeight);

      fieldWidth = maxSize;
      fieldHeight = maxSize;

      // 🛠 Apply Small Offset Correction & Centering (rect.* already in points)
      fieldX = Math.round(fieldX + (pdfRect.width - maxSize) / 2);
      fieldY = Math.round(fieldY + (pdfRect.height - maxSize) / 2);
    }

    // ✅ Check if the width/height is smaller than the minimum
    if (
      !currentProcessingFile?.document?.tempFields?.formFieldTools.checkbox
        .active &&
      !currentProcessingFile?.document?.tempFields?.formFieldTools.radio.active
    ) {
      if (fieldWidth < MIN_WIDTH) {
        fieldX = fieldX - (MIN_WIDTH - fieldWidth) / 2; // Center align
        fieldWidth = MIN_WIDTH;
      }

      if (fieldHeight < MIN_HEIGHT) {
        fieldY = fieldY - (MIN_HEIGHT - fieldHeight) / 2; // Adjust Y to maintain positioning
        fieldHeight = MIN_HEIGHT;
      }
    }

    const activeTool = Object.values(
      currentProcessingFile?.document?.tempFields?.formFieldTools,
    ).find((field) => field.active);

    const uniqueName = `${activeTool?.name}_${Date.now().toString().slice(-4)}`;

    // Map tool names to correct field types
    const getFieldType = (toolName) => {
      switch (toolName) {
        case "checkbox":
          return "PDFCheckBox";
        case "radio":
          return "PDFRadioGroup";
        case "line":
          return "PDFLine";
        case "rectangle":
          return "PDFRectangle";
        case "textField":
        case "date":
        default:
          return "PDFTextField";
      }
    };

    const fieldType = getFieldType(activeTool?.name);

    setCurrentProcessingFile((prevFile) => {
      const maxOrder = [...prevFile.document.tempFields.formFields]?.sort(
        (a, b) => b.order - a.order,
      )?.[0]?.order;
      return {
        ...prevFile,
        document: {
          ...prevFile.document,
          tempFields: {
            ...prevFile.document.tempFields,
            formFields: [
              ...prevFile.document.tempFields.formFields,
              {
                name: uniqueName,
                type: fieldType,
                value: fieldType === "PDFCheckBox" ? false : "",
                x: fieldX, // Convert X to points
                y: fieldY, // Convert Y to points and flip
                width: fieldWidth, // Convert width to points
                height: fieldHeight, // Convert height to points
                page: prevFile?.document?.tempFields?.currentDocument
                  ?.pageNumber,
                fontSize: fieldHeight || 10, // Font size based on height
                fontSizes: [],
                autoFontSize: true,
                order: maxOrder + 1,
              },
            ],
          },
        },
      };
    });

    // Finalize the drawing state
    setIsDrawing(false);
    setRect(null);

    if (fixedInputs.some((prefix) => activeTool?.name.startsWith(prefix))) {
      setCurrentProcessingFile((prevFile) => {
        // Find the matching tool key in formFieldTools based on the name property
        const matchingKey = Object.keys(
          prevFile.document.tempFields.formFieldTools,
        ).find(
          (key) =>
            prevFile.document.tempFields.formFieldTools[key]?.name ===
            activeTool?.name,
        );

        if (!matchingKey) return prevFile; // No match found, return as is

        return {
          ...prevFile,
          document: {
            ...prevFile.document,
            tempFields: {
              ...prevFile.document.tempFields,
              formFieldTools: {
                ...prevFile.document.tempFields.formFieldTools,
                [matchingKey]: {
                  ...prevFile.document.tempFields.formFieldTools[matchingKey],
                  active: false, // Deactivate only this tool
                  disabled: true, // Disable only this tool
                },
              },
            },
          },
        };
      });

      setCurrCursor("default");
    }
  } else if (isSelecting) {
    setIsSelecting(false);
    setSelectionRect(null);
    setFreeSelectStartPoint(null);
  }
};
